/* eslint-disable max-len */

import { useTranslation } from 'react-i18next';
import { CustomError, ManageCodeLabelColumn } from '../../../../components';
import { structure } from '../../../../entityModel';
import {
  TXT_DATA_NOT_FOUND,
  TXT_DELETE,
  TXT_EDIT,
  TXT_LOADING
} from '../../../../translations/translationConstants';
import { capitalizeFirstLetter } from '../../../../shared/stringFunctions';
import { getStructureOutput } from '../../../../api';
import { ApolloError } from '@apollo/client';

export interface ManageStructuresTableBodyProps {
  error?: ApolloError;
  loading: boolean;
  data?: getStructureOutput;
  columns: ManageCodeLabelColumn[];
  onEdit: (structure: structure) => void;
  onDelete: (structure: structure) => void;
}

export const ManageStructuresTableBody =
  ({ error, columns, loading, data, onEdit, onDelete }: ManageStructuresTableBodyProps) => {
    const { t } = useTranslation();
    return (
      <tbody>
        {
          loading &&
          <tr>
            <td colSpan={columns.length} style={{ textAlign: 'center' }}>
              <h3>
                {t(TXT_LOADING).toUpperCase()}
              </h3>
            </td>
          </tr>
        }
        {
          !loading && error && error.message &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {error.message}
              </CustomError>
            </td>
          </tr>
        }
        {
          !loading && data &&
          data.structures && data.structures.items &&
          data.structures.items.length > 0 &&
          data.structures.items.map((structure) => (
            <tr key={`row-${structure.id}`}>
              <td>
                {structure.code}
              </td>
              <td>
                {structure.label}
              </td>
              <td align='center'>
                <button
                  data-target="#modal-structure-editor"
                  data-toggle="modal"
                  className='btn btn-primary'
                  aria-label="edit structure"
                  onClick={() => onEdit(structure)}>
                  {t(TXT_EDIT).toUpperCase()}
                </button>
              </td>
              <td align='center'>
                <button
                  data-target="#modal-default"
                  data-toggle="modal"
                  className='btn btn-danger'
                  aria-label="delete structure"
                  type="button"
                  onClick={() => onDelete(structure)}>
                  {t(TXT_DELETE).toUpperCase()}
                </button>
              </td>
            </tr>
          ))
        }
        {
          !loading &&
          (!data ||
            !data.structures ||
            !data.structures.items ||
            data.structures.items.length <= 0) &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {capitalizeFirstLetter(t(TXT_DATA_NOT_FOUND))}
              </CustomError>
            </td>
          </tr>
        }
      </tbody>
    );
  };
